// extracted by mini-css-extract-plugin
module.exports = {"img":"img___29cif","normal":"normal___oMfhR","rule":"rule___L9sCU"};